import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const token = userService.getToken();
  const router = inject(Router);
  if (userService.isAuthenticated() && token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'X-Locale': 'sr',
        'X-Locale-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Client-Locale': 'sr',
      },
    });
    return next(cloned).pipe(
      catchError((error) => {
        console.log(error);
        if (error.status === 401) {
          userService.clearUserData();
          router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }

  return next(req);
};
